import PropTypes from 'prop-types';
import { AccordionItem, Paragraph, Text as PText, Link } from '@cof/plastic-components';
import ModalLink from '../ModalLink/index';

const ObLandingAccordion = ({ paragraphVariant, textColor, accordion1Path, Text, text, onAboutDOneClick }: any) => (
    <AccordionItem
        heading="How does it work?"
        variant={paragraphVariant}
        data-qa-id="how-does-it-work-accordion"
        paddingBottom={['0.8rem', null, '1.6rem']}
        data-qm-allow
    >
        <>
            <Paragraph
                variant={paragraphVariant}
                // @ts-expect-error TS2322: Type '"400"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultTh
                fontWeight="400"
                data-qa-id="how-does-it-work-text"
                paddingBottom="1.6rem"
                data-qm-allow
            >
                <Text path={accordion1Path} params={{ 'data-qm-allow': 'true' }} />{' '}
            </Paragraph>
            {/* @ts-expect-error TS2322: Type '"400"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultTh */}
            <Paragraph variant={paragraphVariant} fontWeight="400" paddingBottom="1.6rem">
                <Text path="Accordion2" params={{ 'data-qm-allow': 'true' }} />
            </Paragraph>
            {/* @ts-expect-error TS2322: Type '"400"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultTh */}
            <Paragraph variant={paragraphVariant} fontWeight="400" data-qm-allow>
                <PText data-qm-allow color={textColor}>
                    {' '}
                    Want to know more? You can{' '}
                </PText>
                {/* @ts-expect-error TS2322: Type ' children: Element; fontWeight: string; variant: any; onClick: any; "data-qa-id": string; "dat */}
                <ModalLink
                    fontWeight="500"
                    variant={paragraphVariant}
                    onClick={onAboutDOneClick}
                    data-qa-id="learn-more-about-done-link"
                    data-qm-allow
                >
                    <Text path="DOneText.Link1.Text" params={{ 'data-qm-allow': 'true' }} />
                </ModalLink>
                <PText data-qm-allow color={textColor}>
                    {' '}
                    (our Open Banking partner), or{' '}
                </PText>
                <Link
                    external
                    // @ts-expect-error TS2322: Type '"500"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", DefaultTh
                    fontWeight="500"
                    href={text({ path: 'DOneText.Link2.Target' })}
                    variant={paragraphVariant}
                    quantumMetricVisible={true}
                >
                    <Text path="DOneText.Link2.Text" params={{ 'data-qm-allow': 'true' }} />
                </Link>
                <PText data-qm-allow color={textColor}>
                    .
                </PText>
            </Paragraph>
        </>
    </AccordionItem>
);

ObLandingAccordion.propTypes = {
    paragraphVariant: PropTypes.oneOf(['light', 'dark']).isRequired,
    textColor: PropTypes.string.isRequired,
    accordion1Path: PropTypes.string.isRequired,
    Text: PropTypes.func.isRequired,
    text: PropTypes.func.isRequired,
    onAboutDOneClick: PropTypes.func.isRequired
};

export default ObLandingAccordion;
